import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Exam from '@/views/Exam'
import Template from '@/views/Template'
import Question from '@/views/Question'
import QuestionInfo from '@/views/QuestionInfo'
import TemplateInfo from '@/views/TemplateInfo'
import PreviewPdf from '@/views/PreviewPdf'
import addTemplateQuestion from '@/views/addTemplateQuestion'
import sectionInfo from '@/views/SectionInfo'
import Print from '@/views/Print'

import { getUserId } from '../utils/store'
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/exam',
    name: 'Exam',
    component: Exam
  },
  {
    path: '/template',
    name: 'Template',
    component: Template
  },
  {
    path: '/questionInfo',
    name: 'QuestionInfo',
    component: QuestionInfo
  },
  {
    path: '/templateInfo',
    name: 'TemplateInfo',
    component: TemplateInfo
  },
  {
    path: '/addTemplateQuestion',
    name: 'addTemplateQuestion',
    component: addTemplateQuestion
  },
  {
    path: '/sectionInfo',
    name: 'sectionInfo',
    component: sectionInfo
  },
  {
    path: '/question',
    name: 'question',
    component: Question
  },
  {
    path: '/review',
    name: 'PreviewPdf',
    component: PreviewPdf
  },
  {
    path: '/print',
    name: 'Print',
    component: Print
  }
]

const router = new VueRouter({
  linkActiveClass: 'active',
  routes
})
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else {
    var userId = getUserId()
    if (!userId) {
      next({
        path: '/login'
      })
    } else {
      next()
    }
  }
})
export default router
